import { UserRole } from '../../oglasnik-v3/shared/models/user-profile.model';

/**
 * Default home ruta po roli. Candidate → profil; klijent (K5) → svoj račun `/racun`; ostali (employer/admin/subadmin) idu na
 * /dashboard, a početni ekran po ulozi bira ruta `''` dashboarda (`dashboard-v3/pocetni-ekran.ts`):
 * admin i subadmin „Moji zadaci”, izvođač burza ili nastavak onboardinga.
 */
export function roleHomePath(role: UserRole): string[] {
  if (role === 'candidate') return ['/profile'];
  if (role === 'klijent') return ['/racun'];
  return ['/dashboard'];
}
